export default "__VITE_ASSET__HX00MVh8__"